// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%236c757d%27 stroke-width=%272%27%3E%3Cpolyline points=%276 9 12 15 18 9%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg width=%2710%27 height=%276%27 viewBox=%270 0 10 6%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M1 1L5 5L9 1%27 stroke=%27%23999%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Users Page Styles */

.users-page {
  padding: 32px;
  max-width: 1400px;
  margin: 0 auto;
}

/* Header */
.users-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 32px;
}

.users-header-left h1 {
  font-size: 28px;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 4px;
}

.users-header-left p {
  font-size: 14px;
  color: var(--text-secondary);
}

.users-header-actions {
  display: flex;
  gap: 12px;
}

/* Buttons */
.users-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
}

.users-btn svg {
  width: 18px;
  height: 18px;
}

.users-btn-primary {
  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 50%, #8E3A9A 100%);
  color: #fff;
}

.users-btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px -8px rgba(255, 107, 74, 0.5);
}

.users-btn-secondary {
  background: var(--bg-tertiary);
  color: var(--text-primary);
}

.users-btn-secondary:hover {
  background: var(--border-color);
}

.users-btn-danger {
  background: rgba(231, 76, 60, 0.1);
  color: #e74c3c;
}

.users-btn-danger:hover {
  background: rgba(231, 76, 60, 0.2);
}

.users-btn-outline {
  background: transparent;
  border: 1px solid var(--border-color);
  color: var(--text-primary);
}

.users-btn-outline:hover {
  border-color: var(--accent-orange);
  color: var(--accent-orange);
}

.users-password-change {
  display: flex;
  gap: 8px;
  align-items: center;
}

.users-password-change input {
  flex: 1 1;
}

.users-password-change .users-btn {
  white-space: nowrap;
  padding: 12px 16px;
}

.users-btn-small {
  padding: 8px 14px;
  font-size: 13px;
}

.users-btn-small svg {
  width: 14px;
  height: 14px;
}

.users-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

/* Error Message */
.users-error {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  background: rgba(231, 76, 60, 0.1);
  border: 1px solid rgba(231, 76, 60, 0.2);
  border-radius: 12px;
  margin-bottom: 24px;
  color: #e74c3c;
  font-size: 14px;
}

.users-error button {
  background: none;
  border: none;
  color: #e74c3c;
  font-size: 20px;
  cursor: pointer;
  padding: 0 4px;
}

/* Tabs */
.users-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 24px;
  border-bottom: 1px solid var(--border-color);
  padding-bottom: 0;
}

.users-tab {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  background: none;
  border: none;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-secondary);
  cursor: pointer;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  transition: all 0.2s ease;
}

.users-tab:hover {
  color: var(--text-primary);
}

.users-tab.active {
  color: var(--accent-orange);
  border-bottom-color: var(--accent-orange);
}

.users-tab-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  padding: 0 8px;
  background: var(--bg-tertiary);
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.users-tab.active .users-tab-count {
  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 100%);
  color: #fff;
}

/* Filters */
.users-filters {
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
}

.users-search {
  flex: 1 1;
  position: relative;
  max-width: 400px;
}

.users-search svg {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  stroke: var(--text-tertiary);
}

.users-search input {
  width: 100%;
  padding: 12px 14px 12px 44px;
  font-size: 14px;
  border: 1px solid var(--border-color);
  border-radius: 10px;
  background: var(--bg-secondary);
  outline: none;
  transition: border-color 0.2s ease;
}

.users-search input:focus {
  border-color: var(--accent-orange);
}

.users-filters select {
  padding: 12px 36px 12px 14px;
  font-size: 14px;
  border: 1px solid var(--border-color);
  border-radius: 10px;
  background: var(--bg-secondary);
  outline: none;
  cursor: pointer;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 16px;
}

.users-filters select:focus {
  border-color: var(--accent-orange);
}

/* Loading */
.users-loading {
  display: flex;
  justify-content: center;
  padding: 80px 0;
}

.users-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid var(--border-color);
  border-top-color: var(--accent-orange);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Table */
.users-table-container {
  background: var(--bg-secondary);
  border-radius: 16px;
  border: 1px solid var(--border-color);
  overflow-x: auto;
}

.users-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: auto;
  min-width: 900px;
}

.users-table th {
  text-align: left;
  padding: 16px 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--text-tertiary);
  background: var(--bg-tertiary);
  border-bottom: 1px solid var(--border-color);
}

/* Column widths — Users page (8 columns) */
.users-table:not(.clients-table) th,
.users-table:not(.clients-table) td { white-space: nowrap; }

.users-table:not(.clients-table) th:nth-child(5),
.users-table:not(.clients-table) td:nth-child(5) { text-align: center; } /* 2FA */

/* Fixed column widths — Clients page (4 or 5 columns) */
.clients-table th:nth-child(1),
.clients-table td:nth-child(1) { width: 35%; } /* Client */

.clients-table th:nth-child(2):nth-last-child(4),
.clients-table td:nth-child(2):nth-last-child(4) { width: 160px; } /* Office (5-col only) */

.clients-table th:nth-last-child(3),
.clients-table td:nth-last-child(3) { width: 180px; } /* Manager */

.clients-table th:nth-last-child(2),
.clients-table td:nth-last-child(2) { width: 100px; } /* Campaigns */

.clients-table th:last-child,
.clients-table td:last-child { width: 140px; } /* Actions */

.users-table td {
  padding: 16px 20px;
  font-size: 14px;
  border-bottom: 1px solid var(--border-color);
  vertical-align: middle;
}

.users-table tr:last-child td {
  border-bottom: none;
}

.users-table tr:hover td {
  background: var(--bg-tertiary);
}

/* User Cell */
.users-user-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.users-avatar {
  width: 40px;
  min-width: 40px;
  height: 40px;
  border-radius: 10px;
  flex-shrink: 0;
  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
}

.users-user-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.users-user-name {
  font-weight: 600;
  color: var(--text-primary);
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 6px;
}

.users-user-email {
  font-size: 13px;
  color: var(--text-secondary);
  white-space: nowrap;
}

.clients-agency-badge {
  display: inline-block;
  margin-left: 6px;
  padding: 1px 7px;
  font-size: 10px;
  font-weight: 500;
  color: #8E3A9A;
  background: rgba(142, 58, 154, 0.1);
  border-radius: 4px;
  vertical-align: middle;
}

/* Badges */
.users-role-badge {
  display: inline-block;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 6px;
  background: var(--bg-tertiary);
  color: var(--text-primary);
  white-space: nowrap;
}

.users-status-badge {
  display: inline-block;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 6px;
  color: #fff;
}

.users-advertisers-count {
  font-size: 13px;
  color: var(--text-secondary);
}

.users-date {
  font-size: 13px;
  color: var(--text-secondary);
}

.users-date-never {
  color: var(--text-tertiary);
  font-style: italic;
}

/* Icons */
.users-icon {
  width: 20px;
  height: 20px;
}

.users-icon-success {
  stroke: var(--success);
}

.users-icon-muted {
  stroke: var(--text-tertiary);
}

/* Actions */
.users-actions {
  display: flex;
  gap: 8px;
}

.users-action-btn {
  min-width: 32px;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg-tertiary);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.users-action-btn svg {
  width: 16px;
  height: 16px;
  stroke: var(--text-secondary);
}

.users-action-btn:hover {
  background: var(--border-color);
}

.users-action-btn:hover svg {
  stroke: var(--text-primary);
}

.users-action-approve:hover {
  background: rgba(46, 204, 113, 0.1);
}

.users-action-approve:hover svg {
  stroke: var(--success);
}

.users-action-block:hover {
  background: rgba(231, 76, 60, 0.1);
}

.users-action-block:hover svg {
  stroke: var(--danger);
}

.users-action-unblock:hover {
  background: rgba(52, 152, 219, 0.1);
}

.users-action-unblock:hover svg {
  stroke: #3498db;
}

.users-action-pause:hover {
  background: rgba(155, 89, 182, 0.1);
}

.users-action-pause:hover svg {
  stroke: #9b59b6;
}

.users-action-activate:hover {
  background: rgba(46, 204, 113, 0.1);
}

.users-action-activate:hover svg {
  stroke: #2ecc71;
}

/* Empty State */
.users-empty {
  text-align: center;
  padding: 60px 20px;
  color: var(--text-secondary);
}

.users-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 80px 20px;
  text-align: center;
}

.users-empty-state svg {
  width: 64px;
  height: 64px;
  stroke: var(--text-tertiary);
  margin-bottom: 20px;
}

.users-empty-state h3 {
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 8px;
}

.users-empty-state p {
  font-size: 14px;
  color: var(--text-secondary);
  margin-bottom: 24px;
}

/* Invitations Grid */
.users-invitations-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 16px;
}

.users-invitation-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  padding: 20px;
}

.users-invitation-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.users-invitation-email {
  font-weight: 600;
  color: var(--text-primary);
}

.users-invitation-meta {
  display: flex;
  gap: 16px;
  font-size: 13px;
  color: var(--text-secondary);
  margin-bottom: 16px;
}

.users-invitation-actions {
  display: flex;
  gap: 8px;
}

/* Modal */
.users-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 24px;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.users-modal {
  width: 100%;
  max-width: 520px;
  max-height: 90vh;
  background: var(--bg-secondary);
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: slideUp 0.3s ease;
}

.users-modal > form {
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1 1;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.users-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid var(--border-color);
  flex-shrink: 0;
}

.users-modal-header h2 {
  font-size: 18px;
  font-weight: 600;
}

.users-modal-close {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  font-size: 24px;
  color: var(--text-secondary);
  cursor: pointer;
  border-radius: 8px;
  transition: background 0.2s ease;
}

.users-modal-close:hover {
  background: var(--bg-tertiary);
}

.users-modal-body {
  padding: 24px;
  overflow-y: auto;
  min-height: 0;
  flex: 1 1;
}

.users-modal-error {
  padding: 12px 16px;
  background: rgba(231, 76, 60, 0.1);
  border: 1px solid rgba(231, 76, 60, 0.2);
  border-radius: 8px;
  color: #e74c3c;
  font-size: 14px;
  margin-bottom: 20px;
}

.users-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid var(--border-color);
  background: var(--bg-tertiary);
  flex-shrink: 0;
}

/* Form Fields */
.users-form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.users-form-field {
  margin-bottom: 20px;
}

.users-form-field:last-child {
  margin-bottom: 0;
}

.users-form-field label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-secondary);
  margin-bottom: 8px;
}

.users-form-field input,
.users-form-field select {
  width: 100%;
  padding: 12px 14px;
  font-size: 14px;
  border: 1px solid var(--border-color);
  border-radius: 10px;
  background: var(--bg-primary);
  outline: none;
  transition: border-color 0.2s ease;
  appearance: none;
}

.users-form-field select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: right 14px center;
  padding-right: 36px;
  cursor: pointer;
}

.users-form-field input:focus,
.users-form-field select:focus {
  border-color: var(--accent-orange);
}

.users-form-field input:disabled {
  background: var(--bg-tertiary);
  color: var(--text-secondary);
  cursor: not-allowed;
}

/* Advertisers Picker - Clean Design */
.users-advertisers-picker {
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 10px;
  overflow: hidden;
}

/* Selected chips area */
.users-advertisers-chips {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  padding: 10px 12px;
  min-height: 38px;
  background: var(--bg-tertiary);
  border-bottom: 1px solid var(--border-color);
}

.users-advertisers-chips-empty {
  color: var(--text-tertiary);
  font-size: 13px;
  font-style: italic;
}

.users-advertiser-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px 4px 10px;
  background: rgba(255, 107, 74, 0.15);
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  color: #d35400;
}

.users-chip-remove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  background: rgba(0, 0, 0, 0.08);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  padding: 0;
}

.users-chip-remove:hover {
  background: rgba(231, 76, 60, 0.25);
}

.users-chip-remove svg {
  width: 10px;
  height: 10px;
  stroke: #c0392b;
  stroke-width: 2;
}

.users-chips-overflow {
  padding: 4px 10px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  color: var(--text-secondary);
}

/* Header with search and actions */
.users-advertisers-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: var(--bg-secondary);
  border-bottom: 1px solid var(--border-color);
}

.users-search-wrapper {
  position: relative;
  flex: 1 1;
}

.users-search-wrapper svg {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 14px;
  height: 14px;
  stroke: var(--text-tertiary);
  pointer-events: none;
}

.users-advertisers-search {
  width: 100%;
  padding: 8px 12px 8px 40px !important;
  font-size: 13px;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  background: var(--bg-primary);
  outline: none;
  box-sizing: border-box;
}

.users-advertisers-search:focus {
  border-color: var(--accent-orange);
}

.users-advertisers-search::placeholder {
  color: var(--text-tertiary);
}

.users-advertisers-actions {
  display: flex;
  gap: 2px;
  flex-shrink: 0;
}

.users-btn-link {
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 500;
  color: var(--accent-orange);
  background: none;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  white-space: nowrap;
}

.users-btn-link:hover {
  background: rgba(255, 107, 74, 0.1);
}

.users-btn-link.users-btn-clear {
  color: var(--text-secondary);
}

.users-btn-link.users-btn-clear:hover {
  background: var(--bg-tertiary);
}

/* Count indicator in picker */
.users-picker-count {
  padding: 6px 12px;
  font-size: 11px;
  font-weight: 500;
  color: var(--text-tertiary);
  background: var(--bg-tertiary);
  border-bottom: 1px solid var(--border-color);
}

.users-picker-count strong {
  color: var(--accent-orange);
}

/* Advertisers list */
.users-advertisers-list {
  max-height: 180px;
  overflow-y: auto;
  padding: 4px;
}

.users-advertiser-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 8px;
  margin: 0;
  cursor: pointer;
  border-radius: 6px;
  transition: background 0.1s ease;
}

.users-advertiser-item:hover {
  background: var(--bg-tertiary);
}

.users-advertiser-item.selected {
  background: rgba(255, 107, 74, 0.08);
}


/* Custom checkbox visual */
.users-checkbox-custom {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  border: 2px solid #ccc;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
}

.users-advertiser-item:hover .users-checkbox-custom {
  border-color: #999;
}

.users-advertiser-item.selected .users-checkbox-custom {
  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 100%);
  border-color: transparent;
}

.users-checkbox-custom svg {
  width: 10px;
  height: 10px;
  stroke: #fff;
  stroke-width: 3;
  opacity: 0;
}

.users-advertiser-item.selected .users-checkbox-custom svg {
  opacity: 1;
}

.users-advertiser-name {
  flex: 1 1;
  font-size: 13px;
  line-height: 1.3;
  color: var(--text-primary);
}

.users-advertisers-empty {
  padding: 20px;
  text-align: center;
  color: var(--text-tertiary);
  font-size: 13px;
}

/* Admin Access Notice */
.users-admin-access-notice {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px;
  background: linear-gradient(135deg, rgba(255, 107, 74, 0.08) 0%, rgba(142, 58, 154, 0.08) 100%);
  border: 1px solid rgba(255, 107, 74, 0.2);
  border-radius: 10px;
  color: var(--accent-orange);
  font-size: 14px;
  font-weight: 500;
}

.users-admin-access-notice svg {
  flex-shrink: 0;
}

/* Legacy - keep for compatibility */
.users-advertisers-select {
  max-height: 200px;
  overflow-y: auto;
  padding: 12px;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 10px;
}

.users-checkbox-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  cursor: pointer;
  font-size: 14px;
  color: var(--text-primary);
}

.users-checkbox-item input[type="checkbox"] {
  width: 18px;
  height: 18px;
  accent-color: var(--accent-orange);
}

/* Account Info */
.users-account-info {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  background: var(--bg-primary);
  border-radius: 10px;
}

.users-account-info > div {
  display: flex;
  align-items: center;
  gap: 8px;
}

.users-account-label {
  font-size: 13px;
  color: var(--text-secondary);
  min-width: 80px;
}

/* Invite Success */
.users-invite-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 20px 0;
}

.users-invite-success svg {
  width: 64px;
  height: 64px;
  stroke: var(--success);
  margin-bottom: 20px;
}

.users-invite-success h3 {
  font-size: 20px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 8px;
}

.users-invite-success p {
  font-size: 14px;
  color: var(--text-secondary);
  margin-bottom: 16px;
}

.users-invite-link {
  display: flex;
  gap: 8px;
  width: 100%;
}

.users-invite-link input {
  flex: 1 1;
  padding: 12px 14px;
  font-size: 13px;
  border: 1px solid var(--border-color);
  border-radius: 10px;
  background: var(--bg-primary);
  color: var(--text-primary);
}

/* Protected Route Loading */
.protected-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: var(--bg-primary);
}

.protected-spinner {
  width: 48px;
  height: 48px;
  border: 3px solid var(--border-color);
  border-top-color: var(--accent-orange);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* Access Denied */
.access-denied {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: var(--bg-primary);
}

.access-denied-content {
  text-align: center;
  padding: 40px;
}

.access-denied-content svg {
  width: 80px;
  height: 80px;
  stroke: var(--danger);
  margin-bottom: 24px;
}

.access-denied-content h2 {
  font-size: 24px;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 8px;
}

.access-denied-content p {
  font-size: 14px;
  color: var(--text-secondary);
  margin-bottom: 4px;
}

.access-denied-role {
  font-size: 13px;
  color: var(--text-tertiary);
}

/* Responsive */
@media (max-width: 768px) {
  .users-page {
    padding: 20px;
  }

  .users-header {
    flex-direction: column;
    gap: 16px;
  }

  .users-header-actions {
    width: 100%;
  }

  .users-header-actions .users-btn {
    flex: 1 1;
    justify-content: center;
  }

  .users-filters {
    flex-wrap: wrap;
  }

  .users-search {
    max-width: 100%;
    width: 100%;
  }

  .users-filters select {
    flex: 1 1;
    min-width: 120px;
  }

  .users-form-row {
    grid-template-columns: 1fr;
  }
}

/* Office Picker */
.users-office-picker {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.users-office-select {
  width: 100%;
  padding: 12px 14px;
  font-size: 14px;
  border: 1px solid var(--border-color);
  border-radius: 10px;
  background: var(--bg-primary);
  color: var(--text-primary);
  outline: none;
  transition: border-color 0.2s ease;
  box-sizing: border-box;
  cursor: pointer;
}

.users-office-select:focus {
  border-color: var(--accent-orange);
}

.users-office-warning {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  background: rgba(243, 156, 18, 0.1);
  border: 1px solid rgba(243, 156, 18, 0.3);
  border-radius: 8px;
  font-size: 13px;
  color: #b7950b;
}

.users-office-warning svg {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  stroke: #f39c12;
}

.users-office-warning strong {
  color: #b7950b;
}

/* Disabled/Paused user rows */
.users-row-disabled {
  opacity: 0.5;
}

.users-row-disabled:hover {
  opacity: 0.65;
}

.users-row-disabled .users-avatar {
  background: linear-gradient(135deg, #999 0%, #777 100%);
}

/* Delete action button */
.users-action-delete:hover {
  background: rgba(231, 76, 60, 0.1);
}

.users-action-delete:hover svg {
  stroke: #e74c3c;
}
`, "",{"version":3,"sources":["webpack://./src/styles/users.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAEtB;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0EAA0E;EAC1E,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,mDAAmD;AACrD;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,kCAAkC;EAClC,wCAAwC;EACxC,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,4CAA4C;EAC5C,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,oCAAoC;EACpC,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,eAAe;EACf,qCAAqC;EACrC,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,qCAAqC;EACrC,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,yDAAkP;EAClP,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;AACpC;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,sCAAsC;EACtC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,UAAU;AACV;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;EAC3B,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA,2CAA2C;AAC3C;sCACsC,mBAAmB,EAAE;;AAE3D;mDACmD,kBAAkB,EAAE,EAAE,QAAQ;;AAEjF,wDAAwD;AACxD;iCACiC,UAAU,EAAE,EAAE,WAAW;;AAE1D;mDACmD,YAAY,EAAE,EAAE,wBAAwB;;AAE3F;sCACsC,YAAY,EAAE,EAAE,YAAY;;AAElE;sCACsC,YAAY,EAAE,EAAE,cAAc;;AAEpE;+BAC+B,YAAY,EAAE,EAAE,YAAY;;AAE3D;EACE,kBAAkB;EAClB,eAAe;EACf,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,6DAA6D;EAC7D,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mCAAmC;EACnC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA,UAAU;AACV;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA,UAAU;AACV;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,SAAO;AACT;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,SAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,yCAAyC;EACzC,8BAA8B;EAC9B,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,kCAAkC;EAGlC,gBAAgB;AAClB;;AAEA;EACE,yDAAqQ;EACrQ,4BAA4B;EAC5B,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,eAAe;EACf,qCAAqC;EACrC,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;AACtC;;;AAGA,2BAA2B;AAC3B;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,+FAA+F;EAC/F,yCAAyC;EACzC,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,mBAAmB;EACnB,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,sCAAsC;EACtC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;IACP,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,SAAO;IACP,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,mBAAmB;EACnB,6BAA6B;EAC7B,0BAA0B;EAC1B,aAAa;EACb,kCAAkC;EAClC,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uDAAuD;AACzD;;AAEA,yBAAyB;AACzB;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;AACjB","sourcesContent":["/* Users Page Styles */\n\n.users-page {\n  padding: 32px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n/* Header */\n.users-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 32px;\n}\n\n.users-header-left h1 {\n  font-size: 28px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: 4px;\n}\n\n.users-header-left p {\n  font-size: 14px;\n  color: var(--text-secondary);\n}\n\n.users-header-actions {\n  display: flex;\n  gap: 12px;\n}\n\n/* Buttons */\n.users-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 20px;\n  font-size: 14px;\n  font-weight: 600;\n  border-radius: 10px;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.users-btn svg {\n  width: 18px;\n  height: 18px;\n}\n\n.users-btn-primary {\n  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 50%, #8E3A9A 100%);\n  color: #fff;\n}\n\n.users-btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px -8px rgba(255, 107, 74, 0.5);\n}\n\n.users-btn-secondary {\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n}\n\n.users-btn-secondary:hover {\n  background: var(--border-color);\n}\n\n.users-btn-danger {\n  background: rgba(231, 76, 60, 0.1);\n  color: #e74c3c;\n}\n\n.users-btn-danger:hover {\n  background: rgba(231, 76, 60, 0.2);\n}\n\n.users-btn-outline {\n  background: transparent;\n  border: 1px solid var(--border-color);\n  color: var(--text-primary);\n}\n\n.users-btn-outline:hover {\n  border-color: var(--accent-orange);\n  color: var(--accent-orange);\n}\n\n.users-password-change {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.users-password-change input {\n  flex: 1;\n}\n\n.users-password-change .users-btn {\n  white-space: nowrap;\n  padding: 12px 16px;\n}\n\n.users-btn-small {\n  padding: 8px 14px;\n  font-size: 13px;\n}\n\n.users-btn-small svg {\n  width: 14px;\n  height: 14px;\n}\n\n.users-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Error Message */\n.users-error {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 18px;\n  background: rgba(231, 76, 60, 0.1);\n  border: 1px solid rgba(231, 76, 60, 0.2);\n  border-radius: 12px;\n  margin-bottom: 24px;\n  color: #e74c3c;\n  font-size: 14px;\n}\n\n.users-error button {\n  background: none;\n  border: none;\n  color: #e74c3c;\n  font-size: 20px;\n  cursor: pointer;\n  padding: 0 4px;\n}\n\n/* Tabs */\n.users-tabs {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 24px;\n  border-bottom: 1px solid var(--border-color);\n  padding-bottom: 0;\n}\n\n.users-tab {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 20px;\n  background: none;\n  border: none;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-secondary);\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -1px;\n  transition: all 0.2s ease;\n}\n\n.users-tab:hover {\n  color: var(--text-primary);\n}\n\n.users-tab.active {\n  color: var(--accent-orange);\n  border-bottom-color: var(--accent-orange);\n}\n\n.users-tab-count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 24px;\n  height: 24px;\n  padding: 0 8px;\n  background: var(--bg-tertiary);\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.users-tab.active .users-tab-count {\n  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 100%);\n  color: #fff;\n}\n\n/* Filters */\n.users-filters {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 24px;\n}\n\n.users-search {\n  flex: 1;\n  position: relative;\n  max-width: 400px;\n}\n\n.users-search svg {\n  position: absolute;\n  left: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 18px;\n  height: 18px;\n  stroke: var(--text-tertiary);\n}\n\n.users-search input {\n  width: 100%;\n  padding: 12px 14px 12px 44px;\n  font-size: 14px;\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  background: var(--bg-secondary);\n  outline: none;\n  transition: border-color 0.2s ease;\n}\n\n.users-search input:focus {\n  border-color: var(--accent-orange);\n}\n\n.users-filters select {\n  padding: 12px 36px 12px 14px;\n  font-size: 14px;\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  background: var(--bg-secondary);\n  outline: none;\n  cursor: pointer;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%236c757d' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 10px center;\n  background-size: 16px;\n}\n\n.users-filters select:focus {\n  border-color: var(--accent-orange);\n}\n\n/* Loading */\n.users-loading {\n  display: flex;\n  justify-content: center;\n  padding: 80px 0;\n}\n\n.users-spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid var(--border-color);\n  border-top-color: var(--accent-orange);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Table */\n.users-table-container {\n  background: var(--bg-secondary);\n  border-radius: 16px;\n  border: 1px solid var(--border-color);\n  overflow-x: auto;\n}\n\n.users-table {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: auto;\n  min-width: 900px;\n}\n\n.users-table th {\n  text-align: left;\n  padding: 16px 20px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--text-tertiary);\n  background: var(--bg-tertiary);\n  border-bottom: 1px solid var(--border-color);\n}\n\n/* Column widths — Users page (8 columns) */\n.users-table:not(.clients-table) th,\n.users-table:not(.clients-table) td { white-space: nowrap; }\n\n.users-table:not(.clients-table) th:nth-child(5),\n.users-table:not(.clients-table) td:nth-child(5) { text-align: center; } /* 2FA */\n\n/* Fixed column widths — Clients page (4 or 5 columns) */\n.clients-table th:nth-child(1),\n.clients-table td:nth-child(1) { width: 35%; } /* Client */\n\n.clients-table th:nth-child(2):nth-last-child(4),\n.clients-table td:nth-child(2):nth-last-child(4) { width: 160px; } /* Office (5-col only) */\n\n.clients-table th:nth-last-child(3),\n.clients-table td:nth-last-child(3) { width: 180px; } /* Manager */\n\n.clients-table th:nth-last-child(2),\n.clients-table td:nth-last-child(2) { width: 100px; } /* Campaigns */\n\n.clients-table th:last-child,\n.clients-table td:last-child { width: 140px; } /* Actions */\n\n.users-table td {\n  padding: 16px 20px;\n  font-size: 14px;\n  border-bottom: 1px solid var(--border-color);\n  vertical-align: middle;\n}\n\n.users-table tr:last-child td {\n  border-bottom: none;\n}\n\n.users-table tr:hover td {\n  background: var(--bg-tertiary);\n}\n\n/* User Cell */\n.users-user-cell {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.users-avatar {\n  width: 40px;\n  min-width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  flex-shrink: 0;\n  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 100%);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.users-user-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.users-user-name {\n  font-weight: 600;\n  color: var(--text-primary);\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.users-user-email {\n  font-size: 13px;\n  color: var(--text-secondary);\n  white-space: nowrap;\n}\n\n.clients-agency-badge {\n  display: inline-block;\n  margin-left: 6px;\n  padding: 1px 7px;\n  font-size: 10px;\n  font-weight: 500;\n  color: #8E3A9A;\n  background: rgba(142, 58, 154, 0.1);\n  border-radius: 4px;\n  vertical-align: middle;\n}\n\n/* Badges */\n.users-role-badge {\n  display: inline-block;\n  padding: 4px 10px;\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 6px;\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n  white-space: nowrap;\n}\n\n.users-status-badge {\n  display: inline-block;\n  padding: 4px 10px;\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 6px;\n  color: #fff;\n}\n\n.users-advertisers-count {\n  font-size: 13px;\n  color: var(--text-secondary);\n}\n\n.users-date {\n  font-size: 13px;\n  color: var(--text-secondary);\n}\n\n.users-date-never {\n  color: var(--text-tertiary);\n  font-style: italic;\n}\n\n/* Icons */\n.users-icon {\n  width: 20px;\n  height: 20px;\n}\n\n.users-icon-success {\n  stroke: var(--success);\n}\n\n.users-icon-muted {\n  stroke: var(--text-tertiary);\n}\n\n/* Actions */\n.users-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.users-action-btn {\n  min-width: 32px;\n  width: 32px;\n  height: 32px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--bg-tertiary);\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.users-action-btn svg {\n  width: 16px;\n  height: 16px;\n  stroke: var(--text-secondary);\n}\n\n.users-action-btn:hover {\n  background: var(--border-color);\n}\n\n.users-action-btn:hover svg {\n  stroke: var(--text-primary);\n}\n\n.users-action-approve:hover {\n  background: rgba(46, 204, 113, 0.1);\n}\n\n.users-action-approve:hover svg {\n  stroke: var(--success);\n}\n\n.users-action-block:hover {\n  background: rgba(231, 76, 60, 0.1);\n}\n\n.users-action-block:hover svg {\n  stroke: var(--danger);\n}\n\n.users-action-unblock:hover {\n  background: rgba(52, 152, 219, 0.1);\n}\n\n.users-action-unblock:hover svg {\n  stroke: #3498db;\n}\n\n.users-action-pause:hover {\n  background: rgba(155, 89, 182, 0.1);\n}\n\n.users-action-pause:hover svg {\n  stroke: #9b59b6;\n}\n\n.users-action-activate:hover {\n  background: rgba(46, 204, 113, 0.1);\n}\n\n.users-action-activate:hover svg {\n  stroke: #2ecc71;\n}\n\n/* Empty State */\n.users-empty {\n  text-align: center;\n  padding: 60px 20px;\n  color: var(--text-secondary);\n}\n\n.users-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 80px 20px;\n  text-align: center;\n}\n\n.users-empty-state svg {\n  width: 64px;\n  height: 64px;\n  stroke: var(--text-tertiary);\n  margin-bottom: 20px;\n}\n\n.users-empty-state h3 {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 8px;\n}\n\n.users-empty-state p {\n  font-size: 14px;\n  color: var(--text-secondary);\n  margin-bottom: 24px;\n}\n\n/* Invitations Grid */\n.users-invitations-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 16px;\n}\n\n.users-invitation-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  padding: 20px;\n}\n\n.users-invitation-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.users-invitation-email {\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.users-invitation-meta {\n  display: flex;\n  gap: 16px;\n  font-size: 13px;\n  color: var(--text-secondary);\n  margin-bottom: 16px;\n}\n\n.users-invitation-actions {\n  display: flex;\n  gap: 8px;\n}\n\n/* Modal */\n.users-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 24px;\n  animation: fadeIn 0.2s ease;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.users-modal {\n  width: 100%;\n  max-width: 520px;\n  max-height: 90vh;\n  background: var(--bg-secondary);\n  border-radius: 16px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  animation: slideUp 0.3s ease;\n}\n\n.users-modal > form {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  flex: 1;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.users-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid var(--border-color);\n  flex-shrink: 0;\n}\n\n.users-modal-header h2 {\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.users-modal-close {\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  font-size: 24px;\n  color: var(--text-secondary);\n  cursor: pointer;\n  border-radius: 8px;\n  transition: background 0.2s ease;\n}\n\n.users-modal-close:hover {\n  background: var(--bg-tertiary);\n}\n\n.users-modal-body {\n  padding: 24px;\n  overflow-y: auto;\n  min-height: 0;\n  flex: 1 1 0;\n}\n\n.users-modal-error {\n  padding: 12px 16px;\n  background: rgba(231, 76, 60, 0.1);\n  border: 1px solid rgba(231, 76, 60, 0.2);\n  border-radius: 8px;\n  color: #e74c3c;\n  font-size: 14px;\n  margin-bottom: 20px;\n}\n\n.users-modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 16px 24px;\n  border-top: 1px solid var(--border-color);\n  background: var(--bg-tertiary);\n  flex-shrink: 0;\n}\n\n/* Form Fields */\n.users-form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.users-form-field {\n  margin-bottom: 20px;\n}\n\n.users-form-field:last-child {\n  margin-bottom: 0;\n}\n\n.users-form-field label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  margin-bottom: 8px;\n}\n\n.users-form-field input,\n.users-form-field select {\n  width: 100%;\n  padding: 12px 14px;\n  font-size: 14px;\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  background: var(--bg-primary);\n  outline: none;\n  transition: border-color 0.2s ease;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n\n.users-form-field select {\n  background-image: url(\"data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%23999' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 14px center;\n  padding-right: 36px;\n  cursor: pointer;\n}\n\n.users-form-field input:focus,\n.users-form-field select:focus {\n  border-color: var(--accent-orange);\n}\n\n.users-form-field input:disabled {\n  background: var(--bg-tertiary);\n  color: var(--text-secondary);\n  cursor: not-allowed;\n}\n\n/* Advertisers Picker - Clean Design */\n.users-advertisers-picker {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n/* Selected chips area */\n.users-advertisers-chips {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 12px;\n  min-height: 38px;\n  background: var(--bg-tertiary);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.users-advertisers-chips-empty {\n  color: var(--text-tertiary);\n  font-size: 13px;\n  font-style: italic;\n}\n\n.users-advertiser-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 8px 4px 10px;\n  background: rgba(255, 107, 74, 0.15);\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #d35400;\n}\n\n.users-chip-remove {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  background: rgba(0, 0, 0, 0.08);\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  padding: 0;\n}\n\n.users-chip-remove:hover {\n  background: rgba(231, 76, 60, 0.25);\n}\n\n.users-chip-remove svg {\n  width: 10px;\n  height: 10px;\n  stroke: #c0392b;\n  stroke-width: 2;\n}\n\n.users-chips-overflow {\n  padding: 4px 10px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--text-secondary);\n}\n\n/* Header with search and actions */\n.users-advertisers-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  background: var(--bg-secondary);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.users-search-wrapper {\n  position: relative;\n  flex: 1;\n}\n\n.users-search-wrapper svg {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 14px;\n  height: 14px;\n  stroke: var(--text-tertiary);\n  pointer-events: none;\n}\n\n.users-advertisers-search {\n  width: 100%;\n  padding: 8px 12px 8px 40px !important;\n  font-size: 13px;\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  background: var(--bg-primary);\n  outline: none;\n  box-sizing: border-box;\n}\n\n.users-advertisers-search:focus {\n  border-color: var(--accent-orange);\n}\n\n.users-advertisers-search::placeholder {\n  color: var(--text-tertiary);\n}\n\n.users-advertisers-actions {\n  display: flex;\n  gap: 2px;\n  flex-shrink: 0;\n}\n\n.users-btn-link {\n  padding: 6px 10px;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--accent-orange);\n  background: none;\n  border: none;\n  cursor: pointer;\n  border-radius: 4px;\n  white-space: nowrap;\n}\n\n.users-btn-link:hover {\n  background: rgba(255, 107, 74, 0.1);\n}\n\n.users-btn-link.users-btn-clear {\n  color: var(--text-secondary);\n}\n\n.users-btn-link.users-btn-clear:hover {\n  background: var(--bg-tertiary);\n}\n\n/* Count indicator in picker */\n.users-picker-count {\n  padding: 6px 12px;\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--text-tertiary);\n  background: var(--bg-tertiary);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.users-picker-count strong {\n  color: var(--accent-orange);\n}\n\n/* Advertisers list */\n.users-advertisers-list {\n  max-height: 180px;\n  overflow-y: auto;\n  padding: 4px;\n}\n\n.users-advertiser-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 6px 8px;\n  margin: 0;\n  cursor: pointer;\n  border-radius: 6px;\n  transition: background 0.1s ease;\n}\n\n.users-advertiser-item:hover {\n  background: var(--bg-tertiary);\n}\n\n.users-advertiser-item.selected {\n  background: rgba(255, 107, 74, 0.08);\n}\n\n\n/* Custom checkbox visual */\n.users-checkbox-custom {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  border: 2px solid #ccc;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s ease;\n}\n\n.users-advertiser-item:hover .users-checkbox-custom {\n  border-color: #999;\n}\n\n.users-advertiser-item.selected .users-checkbox-custom {\n  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 100%);\n  border-color: transparent;\n}\n\n.users-checkbox-custom svg {\n  width: 10px;\n  height: 10px;\n  stroke: #fff;\n  stroke-width: 3;\n  opacity: 0;\n}\n\n.users-advertiser-item.selected .users-checkbox-custom svg {\n  opacity: 1;\n}\n\n.users-advertiser-name {\n  flex: 1;\n  font-size: 13px;\n  line-height: 1.3;\n  color: var(--text-primary);\n}\n\n.users-advertisers-empty {\n  padding: 20px;\n  text-align: center;\n  color: var(--text-tertiary);\n  font-size: 13px;\n}\n\n/* Admin Access Notice */\n.users-admin-access-notice {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 16px;\n  background: linear-gradient(135deg, rgba(255, 107, 74, 0.08) 0%, rgba(142, 58, 154, 0.08) 100%);\n  border: 1px solid rgba(255, 107, 74, 0.2);\n  border-radius: 10px;\n  color: var(--accent-orange);\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.users-admin-access-notice svg {\n  flex-shrink: 0;\n}\n\n/* Legacy - keep for compatibility */\n.users-advertisers-select {\n  max-height: 200px;\n  overflow-y: auto;\n  padding: 12px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n}\n\n.users-checkbox-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 0;\n  cursor: pointer;\n  font-size: 14px;\n  color: var(--text-primary);\n}\n\n.users-checkbox-item input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  accent-color: var(--accent-orange);\n}\n\n/* Account Info */\n.users-account-info {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px;\n  background: var(--bg-primary);\n  border-radius: 10px;\n}\n\n.users-account-info > div {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.users-account-label {\n  font-size: 13px;\n  color: var(--text-secondary);\n  min-width: 80px;\n}\n\n/* Invite Success */\n.users-invite-success {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 20px 0;\n}\n\n.users-invite-success svg {\n  width: 64px;\n  height: 64px;\n  stroke: var(--success);\n  margin-bottom: 20px;\n}\n\n.users-invite-success h3 {\n  font-size: 20px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 8px;\n}\n\n.users-invite-success p {\n  font-size: 14px;\n  color: var(--text-secondary);\n  margin-bottom: 16px;\n}\n\n.users-invite-link {\n  display: flex;\n  gap: 8px;\n  width: 100%;\n}\n\n.users-invite-link input {\n  flex: 1;\n  padding: 12px 14px;\n  font-size: 13px;\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n}\n\n/* Protected Route Loading */\n.protected-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  background: var(--bg-primary);\n}\n\n.protected-spinner {\n  width: 48px;\n  height: 48px;\n  border: 3px solid var(--border-color);\n  border-top-color: var(--accent-orange);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n/* Access Denied */\n.access-denied {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  background: var(--bg-primary);\n}\n\n.access-denied-content {\n  text-align: center;\n  padding: 40px;\n}\n\n.access-denied-content svg {\n  width: 80px;\n  height: 80px;\n  stroke: var(--danger);\n  margin-bottom: 24px;\n}\n\n.access-denied-content h2 {\n  font-size: 24px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: 8px;\n}\n\n.access-denied-content p {\n  font-size: 14px;\n  color: var(--text-secondary);\n  margin-bottom: 4px;\n}\n\n.access-denied-role {\n  font-size: 13px;\n  color: var(--text-tertiary);\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .users-page {\n    padding: 20px;\n  }\n\n  .users-header {\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .users-header-actions {\n    width: 100%;\n  }\n\n  .users-header-actions .users-btn {\n    flex: 1;\n    justify-content: center;\n  }\n\n  .users-filters {\n    flex-wrap: wrap;\n  }\n\n  .users-search {\n    max-width: 100%;\n    width: 100%;\n  }\n\n  .users-filters select {\n    flex: 1;\n    min-width: 120px;\n  }\n\n  .users-form-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Office Picker */\n.users-office-picker {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.users-office-select {\n  width: 100%;\n  padding: 12px 14px;\n  font-size: 14px;\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  outline: none;\n  transition: border-color 0.2s ease;\n  box-sizing: border-box;\n  cursor: pointer;\n}\n\n.users-office-select:focus {\n  border-color: var(--accent-orange);\n}\n\n.users-office-warning {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 14px;\n  background: rgba(243, 156, 18, 0.1);\n  border: 1px solid rgba(243, 156, 18, 0.3);\n  border-radius: 8px;\n  font-size: 13px;\n  color: #b7950b;\n}\n\n.users-office-warning svg {\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n  stroke: #f39c12;\n}\n\n.users-office-warning strong {\n  color: #b7950b;\n}\n\n/* Disabled/Paused user rows */\n.users-row-disabled {\n  opacity: 0.5;\n}\n\n.users-row-disabled:hover {\n  opacity: 0.65;\n}\n\n.users-row-disabled .users-avatar {\n  background: linear-gradient(135deg, #999 0%, #777 100%);\n}\n\n/* Delete action button */\n.users-action-delete:hover {\n  background: rgba(231, 76, 60, 0.1);\n}\n\n.users-action-delete:hover svg {\n  stroke: #e74c3c;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
